export const SOURCE_RECORDING_PROFILE = {
  label: '1440p quality',
  width: 2560,
  height: 1440,
  frameRate: 12,
  videoBitsPerSecond: 14_000_000,
  audioBitsPerSecond: 128_000,
} as const;

function positiveDimension(value: number | null | undefined, fallback: number) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : fallback;
}

function evenDimension(value: number) {
  return Math.max(2, Math.round(value / 2) * 2);
}

export function getSourceRecordingCanvasSize(params: {
  sourceWidth: number | null | undefined;
  sourceHeight: number | null | undefined;
}) {
  const sourceWidth = positiveDimension(params.sourceWidth, SOURCE_RECORDING_PROFILE.width);
  const sourceHeight = positiveDimension(params.sourceHeight, SOURCE_RECORDING_PROFILE.height);
  const sourceAspect = sourceWidth / sourceHeight;
  const pixelBudget = SOURCE_RECORDING_PROFILE.width * SOURCE_RECORDING_PROFILE.height;
  const maxDimension = Math.max(SOURCE_RECORDING_PROFILE.width, SOURCE_RECORDING_PROFILE.height);
  let width = Math.sqrt(pixelBudget * sourceAspect);
  let height = width / sourceAspect;
  const largestDimension = Math.max(width, height);

  if (largestDimension > maxDimension) {
    const scale = maxDimension / largestDimension;
    width *= scale;
    height *= scale;
  }

  return {
    width: evenDimension(width),
    height: evenDimension(height),
  };
}

export function getContainedDrawRect(params: {
  sourceWidth: number;
  sourceHeight: number;
  targetWidth: number;
  targetHeight: number;
}) {
  const sourceWidth = params.sourceWidth > 0 ? params.sourceWidth : params.targetWidth;
  const sourceHeight = params.sourceHeight > 0 ? params.sourceHeight : params.targetHeight;
  const scale = Math.min(params.targetWidth / sourceWidth, params.targetHeight / sourceHeight);
  const width = sourceWidth * scale;
  const height = sourceHeight * scale;

  return {
    x: (params.targetWidth - width) / 2,
    y: (params.targetHeight - height) / 2,
    width,
    height,
  };
}

export function getCoveredDrawRect(params: {
  sourceWidth: number;
  sourceHeight: number;
  targetWidth: number;
  targetHeight: number;
}) {
  const sourceWidth = positiveDimension(params.sourceWidth, params.targetWidth);
  const sourceHeight = positiveDimension(params.sourceHeight, params.targetHeight);
  const scale = Math.max(params.targetWidth / sourceWidth, params.targetHeight / sourceHeight);
  const width = sourceWidth * scale;
  const height = sourceHeight * scale;

  return {
    x: (params.targetWidth - width) / 2,
    y: (params.targetHeight - height) / 2,
    width,
    height,
  };
}
